import { createBrowserRouter } from 'react-router';

import { RequireAuth, RequireRole } from '@/auth/guards';
import { AppLayout } from '@/components/AppLayout';
import { ComingSoonPage } from '@/pages/ComingSoonPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { LoginPage } from '@/pages/LoginPage';
import { ServerPage } from '@/pages/ServerPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { PalletLink } from '@/pages/stock/PalletLink';
import { SECTIONS } from '@/sections';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  // Десктопный клиент: адрес сервера (T-185).
  { path: '/server', element: <ServerPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/',
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          ...SECTIONS.map((s) => ({
            path: `${s.path.slice(1)}/*`,
            element: (
              <RequireRole min={s.minRole}>
                {s.element ?? <ComingSoonPage titleKey={s.labelKey} day={s.plannedDay} />}
              </RequireRole>
            ),
          })),
          // QR на этикетке палета (ADR-0011) открывает карточку партии.
          { path: 'p/:code', element: <PalletLink /> },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
